/**
 * Menu and Mavigation Element Handlers.
 *
 * @author Industry at Delete
 * @see    https://github.com/industryatdelete
 */
jQuery(document).ready(function($) {
    

    /*
     * Menu Toggle Click Hanglefr
     */
    $('.menu-toggle').on('click', function(e) {
        e.preventDefault(); 
        var menu_open = $('.menu-toggle.open');
        var menu_shut = $('.menu-toggle.shut');
        $('.mobile-menu').toggleClass('open');
        $('html').toggleClass('menu-open');
        $(this).attr('data-state', function(index, attr){
            return attr == 'open' ? 'shut' : 'open';
        });
        $(this).attr('aria-expanded', function(index, attr){
            return attr == 'true' ? 'false' : 'true';
        });
        $(this).attr('aria-hidden', function(index, attr){
            return attr == 'true' ? 'false' : 'true';
        });     
        if (e.currentTarget === this) {
            $('.menu-toggle').not(this).show();
        }
    });


    /*
     * Add Caret Fontawesome Icons
     * For Parent Leve. Dropfons
     */
    $('#mobile-menu .menu-item-has-children').each(function(e){
        $(this).find('ul').before('<i class="fas fa-caret-down"></i>');
        $(this).find('.fas').on('click', function(e){
            $(this).toggleClass('fa-caret-down fa-caret-up');
            $(this).next().toggle();
        });
    });


    /*
     * Cache Xurrebt Window Wisth
     */
    var cachedWidth = $(window).width();


    /*
     * Resize Handler
     */
    $(window).resize(function() {
        var newWidth = $(window).width();
        if (newWidth !== cachedWidth){
            if ($('.mobile-menu').hasClass('open')) {
                $('.mobile-menu').removeClass('open');
                $('html').removeClass('menu-open');
                $('.menu-toggle').attr('data-state', function(index, attr){
                    return attr == 'open' ? 'shut' : 'open';
                });
            }
            cachedWidth = newWidth;
        }
    });
});